import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"


const DataRetention = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>6. Data Retention Policy</Typography>
        <List>
            <ListItem>
                <ListItemText>
                 <b>• Data Retention Duration: </b> All data is retained until the user or company 
account is deleted..
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                   <b>•  Manual Deletion Only: </b> There is no automatic deletion. Users must delete 
records manually via the app or web panel.
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
            <b>• Audit & Legal Compliance: </b> Data is preserved for audit trails and business 
continuity unless deletion is explicitly requested.               
                </ListItemText>
            </ListItem>
             <ListItem>
                <ListItemText>
            <b>• Data Deletion Requests: </b> Users can request deletion through an in-app form 
or by contacting company admins.              
                </ListItemText>
            </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
    </>
  )
}

export default DataRetention